<template>
	<div class="padding-lg" v-loading="loadingPage">
		<div class="text-xxl">{{ $route.meta.title }}</div>
		<div class="padding-top-xl">
			<div class="flex justify-between">
				<el-form :inline="true" :model="formSearch" class="demo-form-inline" label-suffix=":">
					<el-form-item label="编号"><el-input v-model="formSearch.data.id" clearable placeholder="客户编号,精准查找"></el-input></el-form-item>
					<el-form-item label="名称"><el-input v-model="formSearch.data.name" clearable placeholder="客户名称,支持模糊查询"></el-input></el-form-item>
					<el-form-item label="税务类型">
						<el-select v-model="formSearch.data.taxtype" clearable placeholder="税务类型" style="width: 120px;">
							<el-option label="小规模" value="1"></el-option>
							<el-option label="一般" value="2"></el-option>
							<el-option label="其他" value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="创建时间">
						<el-date-picker
							v-model="formSearch.data.addtime"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" native-type="submit" @click="loadinfos">
							<span class="el-icon-search"></span>
							查询
						</el-button>
					</el-form-item>
				</el-form>
				<div>
					<router-link to="/crm/customer/add">
						<el-button type="success" round>
							<span class="el-icon-plus"></span>
							添加客户
						</el-button>
					</router-link>
				</div>
			</div>
			<el-table :data="tableData" stripe style="width: 100%" v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading">
				<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
				<el-table-column prop="name" align="center" label="客户名称">
					<template slot-scope="scope">
						<div class="text-blue text-bold text-left">{{ scope.row.customer.name }}</div>
						<div class="text-grey text-left">{{ scope.row.customer.credit_code }}</div>
					</template>
				</el-table-column>
				<el-table-column align="center" label="联系人" width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.contacter">{{ scope.row.contacter.name }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="type" align="center" label="税务类型" width="120">
					<template slot-scope="scope">
						<span class="cu-tag bg-blue radius light" v-if="scope.row.taxtype == 1">小规模</span>
						<span class="cu-tag bg-red radius light" v-else-if="scope.row.taxtype == 2">一般纳</span>
						<span class="cu-tag radius light" v-else>未知</span>
					</template>
				</el-table-column>
				<el-table-column prop="rank" align="center" label="评级" width="80"></el-table-column>
				<el-table-column prop="service_level" align="center" label="服务等级" width="80"></el-table-column>
				<el-table-column align="center" label="状态" width="80">
					<template slot-scope="scope">
						<span v-if="state_arr">
							<span :class="'cu-tag bg-' + state_arr[scope.row.state].color + ' radius'">{{ state_arr[scope.row.state].name }}</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column align="center" label="服务期限" width="220">
					<template slot-scope="scope">
						<div class="text-gey">
							<span class="">{{ scope.row.begintime }}</span>
							~
							<span :class="scope.row.state == 2 ? 'text-bold text-red' : ''">{{ scope.row.endtime }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" label="顾问岗" width="120">
					<template slot-scope="scope">
						<el-popover placement="top" trigger="click" v-if="scope.row.salesman">
							<div class="">
								<div class="infoshow-line">
									<div class="title">姓名：</div>
									<div class="con">{{ scope.row.salesman_info.name }}</div>
								</div>
								<div class="infoshow-line">
									<div class="title">状态：</div>
									<div class="con">
										<span v-if="scope.row.salesman_info.stateflag" class="cu-tag round bg-green sm">在职</span>
										<span v-else class="cu-tag round bg-gray sm">离职</span>
									</div>
								</div>
								<div class="infoshow-line">
									<div class="title">工号：</div>
									<div class="con">{{ scope.row.salesman_info.officeid }}</div>
								</div>
								<div class="infoshow-line">
									<div class="title">职务：</div>
									<div class="con">{{ scope.row.salesman_info.position }}</div>
								</div>
							</div>
							<span slot="reference">{{ scope.row.salesman_info.name }}</span>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column prop="salesman" align="center" label="账务岗" width="100">
					<template slot-scope="scope">
						<el-popover placement="top" trigger="click" v-if="scope.row.salesman">
							<div class="">
								<div class="infoshow-line">
									<div class="title">姓名：</div>
									<div class="con">{{ scope.row.salesman_info.name }}</div>
								</div>
								<div class="infoshow-line">
									<div class="title">状态：</div>
									<div class="con">
										<span v-if="scope.row.salesman_info.stateflag" class="cu-tag round bg-green sm">在职</span>
										<span v-else class="cu-tag round bg-gray sm">离职</span>
									</div>
								</div>
								<div class="infoshow-line">
									<div class="title">工号：</div>
									<div class="con">{{ scope.row.salesman_info.officeid }}</div>
								</div>
								<div class="infoshow-line">
									<div class="title">职务：</div>
									<div class="con">{{ scope.row.salesman_info.position }}</div>
								</div>
							</div>
							<span slot="reference">{{ scope.row.salesman_info.name }}</span>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column prop="addtime" align="center" label="创建时间" width="160"></el-table-column>
				<el-table-column align="center" label="操作" width="120">
					<template slot-scope="scope">
						<router-link :to="'view/' + scope.row.id"><el-button size="small" type="primary">查看</el-button></router-link>
					</template>
				</el-table-column>
			</el-table>
			<div class="padding-tb text-right">
				<el-pagination
					background
					@size-change="pageSizeChange"
					@current-change="pageChange"
					:current-page="formSearch.page"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="20"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loadingPage: false,
			state_arr: {},
			formSearch: {
				page: 1,
				size: 20,
				data: {}
			},
			total: 0,
			loading: false,
			tableData: []
		};
	},
	beforecreate: function() {},
	created: function() {
		this.loadingPage = true;
		this.$http.post('/server/index.php?m=dljz/fw/list&a=init', this.formSearch).then(
			res => {
				this.loadingPage = false;
				if (res.result == 'ok') {
					this.state_arr = res.data.state_arr;
					this.loadinfos();
				} else {
					this.$alert(res.msg, {
						title: '操作错误',
						type: 'error'
					});
				}
			},
			err => {
				this.loadingPage = false;
				if (err) {
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			}
		);
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		loadinfos() {
			var that = this;
			this.loading = true;
			this.$http.post('/server/index.php?m=dljz/fw/list&a=list', this.formSearch).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.total = res.data.total;
						this.tableData = res.data.infos;
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				err => {
					this.loading = false;
					if (err) {
						this.$alert('网络错误，指定的服务无法访问。', {
							title: '系统错误',
							type: 'error'
						});
					}
				}
			);
		},
		pageChange(page) {
			this.formSearch.page = page;
			this.loadinfos();
		},
		pageSizeChange(size) {
			this.formSearch.size = size;
			this.loadinfos();
		}
	}
};
</script>

<style></style>
